import {
  Badge,
  Box,
  Button,
  IconButton,
  Typography,
  useTheme,
} from "@mui/material";
import { useCallback, useContext, useState } from "react";
import { ColorModeContext, tokens } from "../../theme";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import { dummyProfilePic, ethLogo, notificationIcon } from "../../assets";
import styled from "@emotion/styled";
import { useTypedSelector } from "../../hooks/useTypedSelector";
import { useUIActions } from "../../hooks/useActions";
import {
  getKeyForYieldClaim,
  onYieldDistribution,
} from "../../utils/wallet/apiHelpers";
import { useWeb3React } from "@web3-react/core";
import Loader from "./Loader";
import { InjectedConnector } from "@web3-react/injected-connector";
import { getErrorMessage, Injected } from "../Wallet/WalletConnectors";

const TopbarWrapper = styled(Box)({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  paddingBottom: "12px",
  paddingRight: "60px",
  borderBottom: "2px solid #E8ECF5",
  // marginTop: 24,
});

const BalanceBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-evenly",
  backgroundColor: "#3284FF",
  height: "47px",
  width: "100px",
  borderRadius: "57px",
  marginRight: "10px",
  padding: 2,
  zIndex: 10,
}));

const IconBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: theme.palette.secondary.dark,
  height: "35px",
  width: "35px",
  borderRadius: "35px",
}));

const BalanceAmount = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
});

const IconButtonBox = styled(IconButton)(({ theme }) => ({
  elevation: 3,
  width: "50px",
  height: "50px",
  backgroundColor: theme.palette.secondary.dark,
  zIndex: 10,
}));

const StyledButton = styled(Button)(({ theme, colors, selected }) => ({
  backgroundColor: selected ? colors.primary[500] : colors.whiteAccent[900],
  color: selected ? colors.whiteAccent[900] : colors.primary[500],
  fontSize: "14px",
  fontWeight: 400,
  width: "100%",
  height: "40px",
  borderRadius: "7px",
  borderColor: colors.primary[500],
  marginRight: "15px",
  "&:hover": {
    backgroundColor: colors.primary[600],
    borderColor: colors.primary[500],
    color: colors.whiteAccent[900],
  },
}));

const Topbar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const { setLoading, setSnackbar } = useUIActions();
  const { active, connector, account, activate } = useWeb3React();

  const { balance, balanceInUsd, profileNfts, marketNfts, scholarListNfts } =
    useTypedSelector((state) => state.apiReducer);

  const getKey = async () => {
    const resp = await getKeyForYieldClaim(account);
    console.log("resp for key", resp);
    const finalResp = await onYieldDistribution(
      resp,
      account.toLowerCase(),
      "0x755F974994D15513F662Aa19E5fd2223C72399B7".toLowerCase()
    );
    console.log("finalResp", finalResp);
  };

  const [walletloading, setWalletLoading] = useState(false);

  const connectWallet = () => {
    !active &&
      !(connector instanceof InjectedConnector) &&
      activateWallet(Injected);
  };

  const activateWallet = useCallback(
    (connector, onClose) => {
      setWalletLoading(true);
      if (connector) {
        activate(connector, undefined, true)
          .then((res) => {
            setWalletLoading(false);
          })
          .catch((e) => {
            const err = getErrorMessage(e);
            setWalletLoading(false);
            setSnackbar({
              open: true,
              severity: "error",
              message: err,
            });
          });
      }
    },
    [account]
  );

  return (
    <TopbarWrapper>
      {/* <Button
        color="primary"
        onClick={async () => {
          const abc = await getKey();
          console.log("abc", abc);
        }}
      >
        ACCOUNT ADDRESS
      </Button> */}
      <Box display="flex" alignItems={"center"} justifyContent="center">
        {account ? (
          <BalanceBox>
            <IconBox>
              <img src={ethLogo} alt="eth-logo" />
            </IconBox>
            <BalanceAmount>
              <Typography variant="fs12" color={colors.black[100]}>
                {`${balance} ETH`}
              </Typography>
              <Typography variant="fs9" color={colors.black[100]}>
                (${balanceInUsd})
              </Typography>
            </BalanceAmount>
          </BalanceBox>
        ) : walletloading ? (
          <Loader />
        ) : (
          <StyledButton
            size="lg"
            className="btn-spacing"
            onClick={connectWallet}
            colors={colors}
          >
            Connect Wallet
          </StyledButton>
        )}

        <img
          src={dummyProfilePic}
          alt="notify"
          style={{ width: "48px", height: "48px", borderRadius: "48px" }}
        />
      </Box>
    </TopbarWrapper>
  );
};

export default Topbar;
